module.exports = __webpack_public_path__ + "static/media/classroom_view_move_section_video.a1d4706c.mov";